import { toast } from "react-toastify";

// Matches the API limit in dboroll-API/src/helpers/imageUpload.helper.js.
const IMAGE_MAX_BYTES = 10 * 1024 * 1024;

const getImageUploadError = (files) => {
  for (const file of Array.from(files || [])) {
    if (file.type && !file.type.startsWith("image/")) return `"${file.name}" is not an image.`;
    if (file.size > IMAGE_MAX_BYTES) return `"${file.name}" is larger than 10 MB. Please choose a smaller image.`;
  }
  return "";
};

// Every Admin upload input is an image field: reject oversized or non-image files before the
// form's own onChange runs (capture phase on document runs before React's root listener).
document.addEventListener(
  "change",
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "file") return;
    const error = getImageUploadError(input.files);
    if (!error) return;
    event.stopPropagation();
    input.value = "";
    toast.error(error);
  },
  true
);
